module.exports = __webpack_public_path__ + "img/mejoradeproducto-1.fb66aa5b.jpg";